const STORAGE_KEY = 'fg_saved_projects';

export function getSavedProjects() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
}

export function saveProject(projectId) {
    const saved = getSavedProjects();
    if (!saved.includes(projectId)) {
        saved.push(projectId);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    }
}

export function unsaveProject(projectId) {
    const saved = getSavedProjects().filter(id => id !== projectId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
}

export function isProjectSaved(projectId) {
    return getSavedProjects().includes(projectId);
}